import { render, staticRenderFns } from "./Prism.vue?vue&type=template&id=5d7a787e&lang=pug&"
import script from "./Prism.vue?vue&type=script&lang=ts&"
export * from "./Prism.vue?vue&type=script&lang=ts&"
import style0 from "./Prism.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports